import CustomButton from '@/components/atoms/CustomButton';
import useOrganizationActivation from '@/hooks/organization/useOrganizationActivation';
import { TOrganizationSuperAdminExtended } from '@/types/Organization.types';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';

type Props = {
  organizationData: TOrganizationSuperAdminExtended;
};

const ReactivateOrganization = ({ organizationData }: Props) => {
  const { isPending, mutate } = useOrganizationActivation(organizationData._id, 'reactivate');

  return (
    <VStack
      padding={'40px'}
      boxShadow="0px 10px 80px 0px #00417926"
      background="white"
      borderRadius={'10px'}
      justifyContent={'center'}
      alignItems={'center'}
      marginTop={'15px'}
      maxWidth={'600px'}
      gap={'20px'}
    >
      <Text>
        Reactivating this organization will restore access for all users previously associated with it. Members, admins,
        and support staff will be able to log in and resume activity under the organization.
      </Text>
      <Text>Please confirm that you want to proceed.</Text>
      <CustomButton
        onClick={mutate}
        isLoading={isPending}
        label="Yes, I confirm"
        backgroundColor="extra.teal"
        labelHoverColor="extra.teal"
      />
    </VStack>
  );
};

export default ReactivateOrganization;
